var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.30775 17.5002C2.80908 17.5002 2.38308 17.3236 2.02975 16.9705C1.67658 16.6171 1.5 16.1911 1.5 15.6925V3.00022H0.5V1.50022H5V0.615723H11V1.50022H15.5V3.00022H14.5V15.6925C14.5 16.1976 14.325 16.6252 13.975 16.9752C13.625 17.3252 13.1974 17.5002 12.6923 17.5002H3.30775ZM13 3.00022H3V15.6925C3 15.7823 3.02883 15.8561 3.0865 15.9137C3.14417 15.9714 3.21792 16.0002 3.30775 16.0002H12.6923C12.7692 16.0002 12.8398 15.9681 12.9038 15.904C12.9679 15.84 13 15.7695 13 15.6925V3.00022ZM5.404 14.0002H6.90375V5.00022H5.404V14.0002ZM9.09625 14.0002H10.596V5.00022H9.09625V14.0002Z",
    fill: "#5A606C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.33e912435f4f8fa10968776c3770b016.svg";
export { ForwardRef as ReactComponent };